import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const usuarioService = {
  guardarRecuperarPass,
  getUsuarios,
  guardar,
  updateNoticacionToken,
}

async function getUsuarios(idEmpresa) {
  return await ApiBudgety.get('Usuario/FindAllByIdEmpresa/' + idEmpresa)
}

async function guardarRecuperarPass(body, tokenRC) {
  return await ApiBudgety.post('Usuario/RecuperarContrasena', body, {
    headers: {
      tokenRC,
    },
  })
}

async function guardar(body) {
  return await ApiBudgety.post('Usuario/InsertOrUpdate', body, {
    headers: {
      ACCION: MenusSistema.permisos_usuario.accesos.crear_editar_usuario,
      MENU: MenusSistema.permisos_usuario.id,
    },
  })
}

// uso interno de la app
async function updateNoticacionToken(body) {
  return await ApiBudgety.post('Usuario/UpdateNoticacionToken', body)
}
